<template>
  <v-app id="inspire">
    <v-content style="font-family:Microsoft JhengHei;">
      <v-container fluid fill-height>
        <v-layout align-center justify-center>
          <v-flex xs12 sm8 md6>
            <v-card class="elevation-12">
              <v-toolbar color="red" dark flat>
                <v-toolbar-title style="color:white;" v-if="typeFlag">機關團體註冊</v-toolbar-title>
                <v-toolbar-title style="color:white;" v-if="!typeFlag">機關登入</v-toolbar-title>
                <v-spacer></v-spacer>

                <!-- <v-tooltip right>
                  <template v-slot:activator="{ on }">
                    <v-btn icon large target="_blank" v-on="on" @click="typeFlag = !typeFlag">
                      <v-icon>mdi-account</v-icon>
                    </v-btn>
                  </template>
                  <span>角色切換</span>
                </v-tooltip>-->
              </v-toolbar>
              <v-card-text>
                <v-form ref="form" v-model="valid">
                  <v-col cols="12" md="8">
                    <h2>帳號設定</h2>
                  </v-col>
                  <v-row dense>
                    <v-col cols="12" sm="12" md="8">
                      <v-select
                        :items="getCodeDateUtil('accountType2')"
                        label="使用者類別"
                        dense
                        v-model="member.type"
                        :rules="requiredRules"
                        class="font-weight-normal"
                      ></v-select>
                      <v-checkbox
                        v-model="member.domain"
                        v-if="member.type === 'AAA'"
                        label="是否有開設通譯培訓課程"
                      ></v-checkbox>
                    </v-col>
                    <v-col cols="12" md="8">
                      <v-text-field
                        label="帳號"
                        type="text"
                        :rules="nameRules"
                        counter
                        maxlength="20"
                        class="font-weight-normal"
                        v-model="member.account"
                        :error-messages="txtAccountExists"
                        v-on:change="checkAccount"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="8">
                      <v-text-field
                        id="password"
                        label="密碼"
                        :append-icon="showPassword1 ? 'visibility_off' : 'visibility'"
                        :type="showPassword1 ? 'text' : 'password'"
                        @click:append="showPassword1 = !showPassword1"
                        v-model="pw"
                        clearable
                        required
                        :rules="pwRules"
                        counter
                        maxlength="20"
                        dense
                        class="font-weight-normal"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="8">
                      <v-text-field
                        id="password2"
                        label="確認密碼"
                        :append-icon="showPassword2 ? 'visibility_off' : 'visibility'"
                        :type="showPassword2 ? 'text' : 'password'"
                        @click:append="showPassword2 = !showPassword2"
                        v-model="pw2"
                        clearable
                        required
                        :rules="pw2Rules"
                        counter
                        maxlength="20"
                        dense
                        class="font-weight-normal"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="8"></v-col>
                    <v-col cols="12" md="8"></v-col>
                  </v-row>
                  <v-col cols="12" md="8">
                    <h2>機關團體基本資料</h2>
                  </v-col>
                  <v-row dense>
                    <v-col cols="12" md="8">
                      <v-text-field
                        label="機關代號或統一編號"
                        type="text"
                        :rules="requiredRules"
                        dense
                        class="font-weight-normal"
                        v-model="member.mainDeptId"
                        @input="getDeptName"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="8">
                      <v-text-field
                        label="機關名稱"
                        type="text"
                        :rules="requiredRules"
                        dense
                        readonly
                        class="font-weight-normal"
                        v-model="member.mainDeptName"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="4"></v-col>
                    <v-col cols="12" md="4">
                      <v-select
                        :items="districtArray1"
                        item-text="name"
                        item-value="id"
                        v-model="member.city"
                        @change="districtObjectUtil(member.city);"
                        label="聯絡縣市"
                        dense
                        class="font-weight-normal"
                        :rules="requiredRules"
                      ></v-select>
                    </v-col>
                    <v-col cols="12" md="4">
                      <v-select
                        :items="districtArray2"
                        item-text="name"
                        item-value="id"
                        label="聯絡地區"
                        dense
                        class="font-weight-normal"
                        v-model="member.district"
                        :rules="requiredRules"
                      ></v-select>
                    </v-col>
                    <v-col cols="12" md="8">
                      <v-text-field
                        label="聯絡地址"
                        type="text"
                        :rules="requiredRules"
                        dense
                        class="font-weight-normal"
                        v-model="member.contactAddress"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="8">
                      <v-text-field
                        label="使用者姓名"
                        type="text"
                        :rules="requiredRules"
                        dense
                        class="font-weight-normal"
                        v-model="member.name"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="8">
                      <v-text-field
                        label="職稱"
                        type="text"
                        :rules="requiredRules"
                        dense
                        class="font-weight-normal"
                        v-model="member.titleName"
                      ></v-text-field>
                    </v-col>

                    <v-col cols="12" md="4"></v-col>
                    <v-col cols="12" md="4">
                      <v-text-field
                        id="contactOfficeTel"
                        label="聯絡電話"
                        type="text"
                        :rules="requiredRules"
                        dense
                        class="font-weight-normal"
                        v-model="member.contactOfficeTel"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="4">
                      <v-text-field
                        id="contactOfficeTelExt"
                        label="分機"
                        type="text"
                        dense
                        class="font-weight-normal"
                        v-model="member.contactOfficeTelExt"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="4"></v-col>
                    <v-col cols="12" md="4">
                      <v-text-field
                        id="contactMobileTel"
                        label="傳真"
                        type="text"
                        dense
                        class="font-weight-normal"
                        v-model="member.contactFax"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="4"></v-col>
                    <v-col cols="12" md="8">
                      <v-text-field
                        label="電子信箱"
                        type="text"
                        :rules="emailRules"
                        dense
                        class="font-weight-normal"
                        v-model="member.email"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-form>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="grey lighten-3" style="color:black;" @click="reset();">清除</v-btn>
                <v-btn
                  color="red"
                  style="color:white;"
                  :disabled="(!valid)"
                  class="ma-2"
                  @click="submitObject($event);"
                >註冊</v-btn>
              </v-card-actions>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn text href="javascript:history.go(-1);">
                  <span class="mr-2" style="color:grey;font-size:12px;">回登入頁</span>
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>
  </v-app>
</template>
<script>
import swal from "sweetalert2";
import { mapActions, mapGetters } from "vuex";
import Vue from "vue";
import codeDataUtil from "../../codeDataUtil.js";
Vue.use(codeDataUtil);

export default {
  data() {
    return {
      showPassword1: false,
      showPassword2: false,
      ac: null,
      pw: null,
      pw2: null,
      row1: null,
      member: this.getModel("motorAccount"),
      valid: true,
      accountExists: false,
      txtAccountExists: "",
      formHasErrors: false,
      nameRules: [
        // v => !!v || "Name is required",
        v => !!v || "此欄位是必填",
        v => (v && v.length >= 6) || "必須大於6",
        v => (v && v.length <= 21) || "不能大於20"
      ],
      pwRules: [
        v => !!v || "此欄位是必填",
        v => (v && v.length >= 6) || "必須大於6",
        v => (v && v.length <= 21) || "不能大於20",
        v =>
          /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d).{6,}$/.test(v) ||
          "密碼強度需 6 位數以上，並且至少包含大寫字母、小寫字母、數字各一"
      ],
      pw2Rules: [
        v => !!v || "此欄位是必填",
        v => (v && v.length >= 6) || "必須大於6",
        v => (v && v.length <= 21) || "不能大於20",
        v =>
          /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d).{6,}$/.test(v) ||
          "密碼強度需 6 位數以上，並且至少包含大寫字母、小寫字母、數字各一",
        v => v === this.pw || "和密碼不相符"
      ],
      requiredRules: [v => !!v || "此欄位是必填"],
      selectRequiredRules: [v => v.length != 0 || "此欄位是必填"],
      emailRules: [
        v => !!v || "此欄位是必填",
        v =>
          /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
            v
          ) || "電子信箱格式有誤!"
      ],

      typeFlag: true,
      districtArray1: this.getCodeDateUtil("district"),
      districtArray2: [],
      registerToken: null
    };
  },
  methods: {
    ...mapActions(["updateUser"]),

    checkAccount() {
      var vm = this;
      if (vm.member.account.length > 5)
        vm.axios
          .get(
            vm.idbServerUrl + "idb/member/isAccountExist/" + vm.member.account,
            {
              headers: {
                "Content-Type": "application/json"
              }
            }
          )
          .then(function(response) {
            //console.log("response" + JSON.stringify(response.data));
            vm.accountExists = false;
            vm.txtAccountExists = "";
            if (response.data.exist) {
              vm.accountExists = true;
              vm.txtAccountExists = "帳號重複，請重新設定";
            }
            console.log("accountExists  " + vm.accountExists);
          })
          .catch(function(error) {
            vm.handErrorUtil(error);
            //console.log(error);
          });
    },

    getDeptName() {
      var vm = this;
      vm.axios
        .get(
          vm.idbServerUrl + "idb/code/institutionCode/" + vm.member.mainDeptId
        )
        .then(function(response) {
          vm.member.mainDeptName = response.data.basInstitutionName;
        })
        .catch(function(error) {
          vm.handErrorUtil(error);
          //console.log(error);
        });
    },
    reset() {
      this.$refs.form.reset();
    },
    resetValidation() {
      this.$refs.form.resetValidation();
    },
    submitObject() {
      event.target.disabled = true;
      setTimeout(function() {
        // event.target.disabled = false;
      }, 5000);
      var vm = this;
      vm.member.password = vm.pw;
      vm.member.serviceCity = "";
      vm.member.serviceTime = "";
      vm.member.serviceType = "";
      vm.member.serviceLanguage = "";
      vm.member.lastLoginDate = Math.round(new Date());
      vm.member.status = "W";

      //console.log("!!!!!!!!!! " + this.$refs.form.validate());
      //console.log("!!!!!!!!!! " + JSON.stringify(vm.member));

      vm.axios
        .get(vm.idbServerUrl + "idb/member/getRegisterToken", {})
        .then(function(response) {
          //console.log("register token " + response.data);
          vm.registerToken = response.data;
          var data = {
            registerToken: vm.registerToken,
            memberAccount: vm.member
          };
          vm.axios
            .post(
              vm.idbServerUrl + "idb/member/registerMemberAccount",
              data,
              {}
            )
            .then(function(response) {
              console.log("response " + JSON.stringify(response));
              //vm.successSwalUtil();
              swal({
                title:
                  "您已送出申請表，請發文至本署申請使用通譯人才資料庫，以利審核開通權限。",
                allowOutsideClick: false,
                confirmButtonText: "確認",
                showConfirmButton: true
              });
              vm.reset();
              vm.$router.push({ path: "/Login" });
            })
            .catch(function(error) {
              vm.handErrorUtil(error);
              //console.log("!!!! " + error);
            });
        })
        .catch(function(error) {
          vm.handErrorUtil(error);
          //console.log(error);
        });
    }
  },
  computed: {
    ...mapGetters({
      idbServerUrl: ["getIdbServerUrl"]
    })
  },
  watch: {},
  mounted() {
    this.$refs.form.validate();
  }
};
</script>